import React, { useState, useEffect } from 'react';

import RollDice from './RollDice.js'

// ----------------------------------------------------------------------------------
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function Index(props) {

    // ---------- return html (jsx) ----------

    return (
        <RollDice {...props} />
    )

    };  // end of function

    export default Index